<template>
  <div>
    <v-container fluid class="py-2">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="elevation-5">
            <v-container fluid class="py-0 pb-2">
              <v-layout row wrap>
                <v-flex xs12 sm9>
                  <v-container fluid class="py-0">
                    <v-layout column>
                      <v-flex xs12>
                        <v-card-title class="pa-2">
                          <div v-if="$vuetify.breakpoint.smAndUp">
                            <img
                              v-for="(i, imginx) in tomarAer(cupo)"
                              :src="i"
                              class="icon-aereolinea-as"
                              :key="`imgi-${imginx}`"
                            />
                          </div>
                          <v-spacer> </v-spacer>
                          <div>
                            <div v-bind:class="classTitle">
                              {{ cupo.descripcion }}
                            </div>
                          </div>
                          <v-spacer> </v-spacer>
                          <v-tooltip v-model="showTtFils" top v-if="usuario.nivel == 2">
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" @click="showFiles">
                                <v-icon color="red darken-4">view_list</v-icon>
                              </v-btn>
                            </template>
                            <span>Ver files</span>
                          </v-tooltip>
                        </v-card-title>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <ResumenItinerario :resumen="cupo.ida" :idxcupo="'ida' + index" />
                        <ResumenItinerario :resumen="cupo.vuelta" :idxcupo="'vuelta' + index" />
                      </v-flex>
                      <v-flex xs12 v-if="cupo.notas">
                        <v-alert outline :value="true" color="info" icon="info" class="py-2">
                          <p class="my-0 body-1 black--text font-weight-light caption">
                            {{ cupo.notas }}
                          </p>
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm3 class="border-left">
                  <v-container style="height: 100%;" class="pb-1">
                    <v-layout justify-space-around column fill-height>
                      <p class="text-center grey--text darken-2  caption">
                        Ruta {{ cupo.ruta }}
                        <span> Disponibles {{ cupo.disponibles }}</span>
                      </p>
                      <h3 class="text-center my-1 font-weight-bold">
                        {{ cupo.totales.moneda }}
                        {{ cupo.totales.venta + cupo.totales.tasa }}
                      </h3>
                      <p class="text-center mb-0 body-1">
                        <small>
                          Precio total para:
                        </small>
                      </p>
                      <p class="text-center mb-0 body-1">
                        <small>{{ cupo.totales.adl }} Adulto/s</small>
                        <small v-if="cupo.totales.chd > 0"> | {{ cupo.totales.chd }} menor/es</small>
                        <small v-if="cupo.totales.bebe > 0"> | {{ cupo.totales.bebe }} infante/s</small>
                      </p>
                      <p class="text-center body-1">
                        <small> con impuestos incluídos</small>
                      </p>
                      <p class="tarCont text-center mb-0 body-1">
                        <small>
                          <a :id="'popTarifas' + index" class="a-btn-as cur-pointer">
                            Ver detalle
                          </a>
                        </small>
                      </p>
                      <p class="tarCont text-center mb-1 body-1">
                        <b-form-checkbox
                          v-if="app.reservableHotel"
                          :id="`checkbox1-${index}`"
                          v-model="buscaHtl"
                          :disabled="!posibleBusquedaHtl || cupo.disponibles < cantPaxRq"
                        >
                          Buscar hoteles
                        </b-form-checkbox>
                      </p>
                      <p class="tarCont text-center mb-1 body-1" v-if="!posibleBusquedaHtl">
                        <small class="text-danger">
                          No es posible la búsqueda de hoteles
                        </small>
                        <v-icon class="ml-1 text-warning">fas fa-exclamation-triangle</v-icon>
                      </p>
                      <v-layout align-end justify-center fill-height wrap>
                        <v-flex x12 v-if="!app.reservableHotel" class="text-center">
                          <v-chip label small class="caption" color="yellow accent-3">
                            <v-icon left small>warning</v-icon>
                            <span>
                              No hará la búsqueda de hoteles
                            </span>
                          </v-chip>
                        </v-flex>
                        <v-flex xs12>
                          <v-btn
                            :disabled="cupo.disponibles < cantPaxRq"
                            block
                            @click="buscarHoteles()"
                            color="primary"
                            >{{ cupo.disponibles < cantPaxRq ? "Sin disponibilidad" : "Seleccionar" }}</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <b-popover
      :target="'popTarifas' + index"
      triggers="click"
      :show.sync="popoverShowTar"
      placement="top"
      container="tarCont"
      ref="popover"
    >
      <ul class="list-group list-group-flush">
        <li v-for="(t, index) in cupo.tarifas" class="list-group-item py-0 px-0" :key="`tidx-${index}`">
          <p class="mb-0 caption">
            {{ t.tipo }} tarifa {{ t.moneda }} {{ t.venta }} + tasas {{ t.moneda }} {{ t.tasa }}
          </p>
        </li>
      </ul>
    </b-popover>
    <v-dialog v-model="panelFiles" max-width="70%">
      <v-card>
        <v-card-text>
          <v-alert :value="true" type="info" class="text-center" v-if="fileBuscado && files.length == 0">
            No hay files asociados a este cupo.
          </v-alert>

          <table style="width:100%" class="text-center">
            <tr>
              <th>File</th>
              <th>Pasajero</th>
              <th>Agencia</th>
              <th>Cantidad</th>
              <th>Status</th>
            </tr>
            <tr v-for="(f, findx) in files" :key="`fcupo-${findx}`">
              <td>{{ f.nrfile }}</td>
              <td>{{ f.pasajero }}</td>
              <td>{{ f.agencia }}</td>
              <td>{{ f.cantidad }}</td>
              <td>{{ f.status }}</td>
            </tr>
          </table>

          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-4" flat="flat" @click="panelFiles = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/utiles/Loading.vue"
import { mapGetters } from "vuex"
const ResumenItinerario = () => ({
  // The component to load (should be a Promise)
  component: import("@/components/cupos/ResumenItinerario.vue"),
  // A component to use while the async component is loading
  loading: Loading,
  // A component to use if the load fails
  // error: ErrorComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 1,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
})
import moment from "moment"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
export default {
  props: ["cupo", "index", "busqueda"],
  data: function() {
    return {
      popoverShowTar: false,
      buscaHtl: true,
      showTtFils: false,
      panelFiles: false,
      files: [],
      fileBuscado: false,
      loading: false,
      classTitle: {
        title: this.$vuetify.breakpoint.mdAndUp,
        "body-2": this.$vuetify.breakpoint.smAndDown,
        "font-weight-light": true
      }
    }
  },
  mounted() {},
  components: {
    ResumenItinerario
  },
  methods: {
    tomarAer(cupo) {
      let aerolineasurl = []
      cupo.ida.map(i =>
        aerolineasurl.push("https://www.allseasons.tur.ar/ws/utiles/img/aerolineas/" + i.aerolinea.codigo + ".png")
      )
      cupo.vuelta.map(v =>
        aerolineasurl.push("https://www.allseasons.tur.ar/ws/utiles/img/aerolineas/" + v.aerolinea.codigo + ".png")
      )
      return this.$lodash.uniq(aerolineasurl)
    },
    completarBusqueda() {
      let checkin = this.armarCheckinHotel(this.cupo.ida)
      var checkout = moment(this.cupo.vuelta[this.cupo.vuelta.length - 1].salida.fecha).format("YYYY-MM-DD")
      var busquedaPost = this.busqueda
      busquedaPost["checkin"] = checkin
      busquedaPost["checkout"] = checkout
      busquedaPost["isDc"] = false
      var methodData = {
        method: "POST",
        url: process.env.VUE_APP_ASBACK + "/api/get-disponibilidad",
        data: busquedaPost
      }
      return methodData
    },
    buscarHoteles() {
      this.$store.dispatch("carrito/limpiar", { tipo: "c" })
      this.$store.dispatch("carrito/agregar", { tipo: "c", data: this.cupo })
      if (this.buscaHtl && this.app.reservableHotel) {
        var data = this.armarParametros2Espera()
        this.$router.replace({ name: "buscandox", params: { data: data } })
        return
      }
      this.$router.push({ name: "pasajerosCupoAgencias" })
    },
    armarParametros2Espera() {
      var methodData = this.completarBusqueda()
      var to = "hotelesCupos"
      var redirect = {
        to: "inicio",
        mensaje: "No se encontraron hoteles, será redirigido al buscador"
      }
      var data2To = { busqueda: methodData.data }
      return {
        to: to,
        redirect: redirect,
        methodData: methodData,
        data2To: data2To,
        mensaje: "Buscando hoteles"
      }
    },
    armarCheckinHotel(ida) {
      let inicial = moment(ida[0].salida.fecha)
      let llegada = moment(ida[this.cupo.ida.length - 1].llegada.fecha)
      inicial.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      llegada.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      if (llegada.diff(inicial, "days", true) > 0 && moment(ida[0].llegada.fecha).hour() >= 6) {
        return moment(ida[this.cupo.ida.length - 1].llegada.fecha).format("YYYY-MM-DD")
      }
      return moment(ida[0].salida.fecha).format("YYYY-MM-DD")
    },
    showFiles() {
      this.panelFiles = true
      if (!this.fileBuscado) {
        this.getFilesAsociados(this.cupo.ida[0].idTramo)
      }
    },
    async getFilesAsociados(tramo) {
      this.loading = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/cupos-files/" + tramo, header)
      axios.overlay(false)
      await axios.exe()
      this.files = axios.getData().files
      this.loading = false
      this.fileBuscado = true
    }
  },
  computed: {
    posibleBusquedaHtl: function() {
      if (this.busqueda != null) {
        return true
      }
      this.buscaHtl = false
      return false
    },
    ...mapGetters("app", {
      usuario: "getUsuario",
      app: "getApp"
    }),
    ...mapGetters("cupo", {
      cantPaxRq: "getCantPaxRq"
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-nav-tabs {
  border-bottom: 0;
}
.nav-link-as {
  padding: 0.1rem 1rem;
}
hr {
  margin-top: 0;
}
.a-btn-as:hover {
  color: #007bff;
  text-decoration: underline !important;
}
.a-btn-as {
  color: #007bff !important;
}
.resultContainer {
  height: 76px;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>
